export default "__VITE_ASSET__BByG65R$__"